
export const corPrimaria = "#41D3BE"

export const fundoClaro  = "#F1F1F1"
export const conteudoClaro = "WHITE"
export const textoFundoClaro = "GREY31"


export const fundoEscuro = "#5C5B5E"
export const conteudoEscuro = "WHITE"
export const textoFundoEscuro = "#F5F5F5"
